import React, { useState, useEffect, useRef, useContext } from "react";
import { useNavigate } from "react-router-dom";
import "react-tooltip/dist/react-tooltip.css";
import { Tooltip } from "react-tooltip";
import {
    UiOrderDetails,
    UiOrderDetailsColWr,
    UiOrderDetailsColName,
    UiOrderDetailsColStatus,
    UiOrderDetailsColValidUnit,
    UiOrderDetailsColLabel,
    UiOrderDetailsLastColWr,
    UiOrderDetailsLastCol,
    UiOrderDetailsLastColBtnWr,
    UiVoucherDetailsWr,
} from "../../../_uiComponents/common/UiProductElements";
import UiBarcode from "../../../_uiComponents/common/UiBarcode";
import {
    UiCol,
    UiSingleRow,
    UiRowContainer,
} from "../../../_uiComponents/grid-container/GridContainer";
import VoucherWalletContent from "./VoucherWalletContent";
import { UiModal } from "../../../_uiComponents/common/UiModal";
import {
    timeFormatUtcToLocal,
    kFormatter,
} from "../../../../_helpers/support.services";
import { orderStatus } from "../../../../_redux/_constants/";
import {
    UiBottomNavBar,
    UiBottomNavBarItem,
} from "../../../_uiComponents/common/UiBottomNavBar";

import TodoIcon from "../../../../styles/img/bottom-nav-todo.png";
import RewardsIcon from "../../../../styles/img/bottom-nav-rewards.png";
import HelpIcon from "../../../../styles/img/help-icon.png";
import BottomNavIcon from "../../../../styles/img/bottom-nav-campaigns.png";
import UiWalletCard from "../../../_uiComponents/cards/UiWalletCard";
import { UiSlider } from "../../../_uiComponents/common/UiSlider";
import {
    UiNextArrow,
    UiPrevArrow,
} from "../../../_uiComponents/common/UiSliderArrows";
import {
    shopVoucherWalletRequest,
    shopVoucherRedeemRequest,
    shopRateVoucherRequest,
} from "../../../../_redux/_actions";
import { useSelector, useDispatch } from "react-redux";
// import copy from "copy-to-clipboard";
import { UiWalletZeroState } from "../../../_uiComponents/cards/UiWalletZeroState";
import { UiWalletModal } from "../../../_uiComponents/common/UiModal";
import {
    UiButtonPrimary,
    UiButtonIcon,
    UiButtonSecondary,
} from "../../../_uiComponents/form/UiButton";
import { UiVoucherLoading } from "../../../_uiComponents/common/UiLoadingSpinner";
import { useReactToPrint } from "react-to-print";
import GiftLogo from "../../../../styles/img/gift-mall-logo.png";
// import { socket } from "../../../../_helpers/support.services";
import { Rating } from "react-simple-star-rating";
import CloseWhiteIcon from "../../../../styles/img/close-white-icon.png";
import { Context } from "../../../../_context/Store";
import { signalrTopics } from "../../../..//_redux/_constants";
import CloneIcon from "../../../../styles/img/svg/CloneIcon";

export default function VoucherDetails(props) {
    const [showQrModal, setShowQrModal] = useState(false);
    const [showWalletModal, setWalletModal] = useState(false);
    const [copyText, setCopyText] = useState("");
    const [activeModal, setActiveModal] = useState(0);
    const [cardNumberCopy, setCardNumberCopy] = useState(null);

    const actionDispatch = useDispatch();

    const [state, dispatch] = useContext(Context);

    const { voucherWallet, auth } = useSelector((state) => {
        return {
            voucherWallet: state.shop.voucherWallet,
            auth: state.auth,
        };
    });

    // const componentRef = useRef();
    // const handlePrint = useReactToPrint({
    //     pageStyle: `@media print {
        
    //     }`,
    //     content: () => componentRef.current,
    // });

    const [activeOrder, setActiveOrder] = useState(null);
    useEffect(() => {
        actionDispatch(shopVoucherWalletRequest());
    }, []);

    useEffect(() => {
        if (state.signalRConnaction) {
            console.log("getting connections");
            state.signalRConnaction.on(
                signalrTopics.GET_VOUCHER_UPDATE,
                (message) => {
                    message = JSON.parse(message);
                    //{"UserId":2000007,"ParticipantId":2000007,"OrderId":19,"Status":2,"StatusValue":"2"}

                    if (message.UserId == auth.userProfileDetails.userId) {
                        actionDispatch(
                            shopVoucherWalletRequest({ loadingHide: true }),
                        );
                    }
                },
            );
        }
        return () => {
            if (state.signalRConnaction) {
                state.signalRConnaction.off(signalrTopics.GET_VOUCHER_UPDATE);
            }
        };
    }, [state.signalRConnaction]);

    const navigate = useNavigate();

    const showHideQr = (order) => {
        setActiveOrder(order);
        showQrModal ? setShowQrModal(false) : setShowQrModal(true);
    };

    const navigateUrl = (url) => {
        window.open(url, "_blank");
    };

    const UiMainSlider = {
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 3.75,
        slidesToScroll: 1,
        nextArrow: <UiNextArrow />,
        prevArrow: <UiPrevArrow />,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    dots: false,
                    slidesToScroll: 1,
                    infinite: false,
                },
            },
        ],
    };

    const [activeStep, setActiveStep] = useState([]);

    const redeemClick = (id) => {
        setActiveStep((current) => [...current, id]);
        actionDispatch(shopVoucherRedeemRequest({ id }));
    };
    const resetClick = (id) => {
        setActiveStep((current) => current.filter((item) => item !== id));
        actionDispatch(shopVoucherRedeemRequest({ id }));
    };
    const copyToClipboard = async (id) => {
        await navigator.clipboard.writeText(id);
    };

    const walletModalHide = () => {
        // setWalletModal(false);
        setActiveModal(0);
    };

    const handleModalClose = () => {
        setActiveModal(0);
    };

    const showWalletModalClick = (orderId) => {
        setActiveModal(orderId);
        // setWalletModal(true);
    };

    const handleRating = (rating, orderId) => {
        actionDispatch(shopRateVoucherRequest({ orderId, rating }));
    };

    return (
        <>
            <UiModal
                modalShowHide={showHideQr}
                show={showQrModal}
                title="Voucher Code"
            >
                {activeOrder && (
                    <UiSingleRow>
                        <UiBarcode value={activeOrder.cardNumber || ""} />
                        <UiBarcode value={activeOrder.pinNumber || ""} />
                    </UiSingleRow>
                )}
            </UiModal>
            <div className="sb-wallet-slider">
                {voucherWallet.length > 0 ? (
                    <UiSlider UiSliderSettings={UiMainSlider}>
                        {voucherWallet.map((order, id) => (
                            <>
                                <div
                                    key={id}
                                    id={order.orderId}
                                    onClick={() => {
                                        showWalletModalClick(order.orderId);
                                    }}
                                >
                                    <UiRowContainer>
                                        <UiCol lg="12">
                                            <UiWalletCard
                                                key={id}
                                                title={order.orderName}
                                                points={kFormatter(
                                                    order.totalPoints,
                                                )}
                                                img={order.imageUrl}
                                                viewOrder={() =>
                                                    navigate(
                                                        "/app/shop/order-details/" +
                                                        order.orderId,
                                                    )
                                                }
                                            >
                                                {(activeStep.find(
                                                    (element) =>
                                                        element ===
                                                        order.orderId,
                                                ) ||
                                                    order.isRedeemed) && (
                                                        <div className="sb-walletcard__redeemed">
                                                            {/* <img src={CloseWhiteIcon} onClick={handleModalClose}/> */}
                                                            <h4>Redeemed</h4>
                                                            <div className="sb-walletcard__rating">
                                                                <h5>
                                                                    Rate this
                                                                    voucher{" "}
                                                                </h5>
                                                                <div
                                                                    onClick={(
                                                                        event,
                                                                    ) => {
                                                                        event.stopPropagation();
                                                                    }}
                                                                >
                                                                    <Rating
                                                                        initialValue={
                                                                            order.rating
                                                                        }
                                                                        onClick={(
                                                                            e,
                                                                        ) =>
                                                                            handleRating(
                                                                                e,
                                                                                order.orderId,
                                                                            )
                                                                        }
                                                                    />
                                                                </div>
                                                                <div className="ratingcontent">
                                                                    Rate how much
                                                                    you like this
                                                                    voucher so that
                                                                    others can
                                                                    benefit from
                                                                    your experience.
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )}
                                            </UiWalletCard>
                                        </UiCol>
                                    </UiRowContainer>
                                </div>

                                <UiWalletModal
                                    modalShowHide={walletModalHide}
                                    show={activeModal === order.orderId}
                                    title={order.orderName}
                                    points={kFormatter(order.totalPoints)}
                                // backdrop="static"
                                >
                                    <div
                                        // ref={componentRef}
                                        className="sb-print-to-component"
                                    >
                                        <div className="sb-react-to-print">
                                            <h3>{order.orderName}</h3>
                                            <h4>
                                                {kFormatter(order.totalPoints)}
                                            </h4>
                                        </div>
                                        <div className="sb-react-to-print-img">
                                            <img src={order.imageUrl} />
                                        </div>

                                        <div className="sb-wallet-pin-no">
                                            {/* {order.cardNumber &&
                                                <>
                                                    <div className="sb-wallet-pin-no__nos">
                                                        Card #: {""}
                                                        {order.cardNumber}
                                                        <a
                                                            data-tooltip-id="card-tooltip"
                                                            data-tooltip-content={
                                                                cardNumberCopy ==
                                                                    order.cardNumber
                                                                    ? "Copied"
                                                                    : "Copy Code"
                                                            }
                                                        >
                                                            <span
                                                                onClick={() => {
                                                                    navigator.clipboard.writeText(
                                                                        order.cardNumber,
                                                                    ),
                                                                        setCardNumberCopy(
                                                                            order.cardNumber,
                                                                        );
                                                                }}
                                                            >
                                                                <CloneIcon />
                                                            </span>
                                                        </a>

                                                    </div>
                                                    <br />
                                                </>
                                            } */}
                                            {/* {order.pinNumber &&
                                                <>
                                                    <div className="sb-wallet-pin-no__nos">

                                                        Pin: {""} {order.pinNumber}
                                                        <a
                                                            data-tooltip-id="card-tooltip"
                                                            data-tooltip-content={
                                                                cardNumberCopy ==
                                                                    order.pinNumber
                                                                    ? "Copied"
                                                                    : "Copy Code"
                                                            }
                                                        >
                                                            <span
                                                                onClick={() => {
                                                                    navigator.clipboard.writeText(
                                                                        order.pinNumber,
                                                                    ),
                                                                        setCardNumberCopy(
                                                                            order.pinNumber,
                                                                        );
                                                                }}
                                                            >
                                                                <CloneIcon />
                                                            </span>
                                                        </a>
                                                    </div>
                                                </>
                                            } */}
                                            
                                                <div className="sb-wallet-redeem-btn-wr">
                                                    <UiButtonPrimary
                                                        disabled={
                                                            typeof order?.redemptionUrl ==
                                                            "undefined"
                                                        }
                                                        btnName="Activate & Get Code"
                                                        onClick={() =>
                                                            navigateUrl(
                                                                order?.redemptionUrl,
                                                            )
                                                        }
                                                    />
                                                </div>
                                                
                                        </div>
                                        <Tooltip
                                            id="card-tooltip"
                                            place="right"
                                            className="sb-shop-tooltip-class"
                                        />
                                        <h5>Redeem online</h5>
                                        <p
                                            dangerouslySetInnerHTML={{
                                                __html: order?.redemptionInfo,
                                            }}
                                        ></p>
                                        <h5>Redeem in store</h5>
                                        <p
                                            dangerouslySetInnerHTML={{
                                                __html: order?.redemptionInfo,
                                            }}
                                        ></p>
                                        <h5>Terms and Conditions</h5>
                                        <p
                                            dangerouslySetInnerHTML={{
                                                __html: order?.terms,
                                            }}
                                        ></p>

                                        <div className="sb-wallet-modal-footer">
                                            {/* <UiButtonPrimary
                                                btnName="Print"
                                                onClick={() =>
                                                    navigateUrl(
                                                        order?.redemptionUrl,
                                                    )
                                                }
                                            /> */}


                                            {order.isRedeemed ? (
                                                <div className="sb-wallet-reset">
                                                    <UiButtonPrimary
                                                        btnName="Reset"
                                                        onClick={() =>
                                                            resetClick(
                                                                order.orderId,
                                                            )
                                                        }
                                                    />
                                                </div>
                                            ) : (
                                                <div className="sb-wallet-redeem">
                                                    <UiButtonPrimary
                                                        btnName="Redeemed"
                                                        onClick={() =>
                                                            redeemClick(
                                                                order.orderId,
                                                            )
                                                        }
                                                    />
                                                </div>
                                            )}
                                        </div>
                                       
                                        {(order.orderStatus === 5 ||
                                            order.orderStatus === 1) && (
                                                <div className="sb-walletcard__preparing">
                                                    <img
                                                        className="close"
                                                        src={CloseWhiteIcon}
                                                        onClick={handleModalClose}
                                                    />
                                                    <div className="sb-voucher-loader-content">
                                                        <div className="loader"></div>
                                                        <h3>
                                                            We're preparing <br />
                                                            your voucher
                                                        </h3>
                                                        <h5>
                                                            Please wait a few more
                                                            seconds
                                                        </h5>
                                                    </div>
                                                </div>
                                            )}

                                        <div className="sb-footer-logo-section">
                                            <div className="sb-footer-logo-section__left">
                                                <img src={GiftLogo} />
                                                <h5>
                                                    Powered by Gift Card Mall
                                                </h5>
                                            </div>
                                            <div className="sb-footer-logo-section__right">
                                                <h5>
                                                    {" "}
                                                    © 2023 GiftCardMall.com
                                                </h5>
                                            </div>
                                        </div>
                                    </div>
                                </UiWalletModal>
                            </>
                        ))}
                    </UiSlider>
                ) : (
                    <UiWalletZeroState />
                )}
            </div>

            {/* <UiVoucherLoading voucherLoader={false} /> */}

            <div id="product"></div>
            {/* <UiVoucherDetailsWr>
                <UiOrderDetails>
                    <UiSingleRow>
                        <UiCol lg="4">
                            <UiOrderDetailsColWr>
                                <UiOrderDetailsColName colName="Order Number" />
                                <UiOrderDetailsColLabel
                                    label={props.order.orderNumber}
                                />
                            </UiOrderDetailsColWr>
                            <UiOrderDetailsColWr>
                                <UiOrderDetailsColName colName="Date" />
                                <UiOrderDetailsColLabel
                                    label={timeFormatUtcToLocal(
                                        props.order.orderDate,
                                    )}
                                />
                            </UiOrderDetailsColWr>
                        </UiCol>
                        <UiCol lg="4">
                            <UiOrderDetailsColWr>
                                <UiOrderDetailsColName colName="Order Name" />
                                <UiOrderDetailsColLabel
                                    label={props.order.orderName}
                                />
                            </UiOrderDetailsColWr>
                            <UiOrderDetailsColWr>
                                <UiOrderDetailsColName colName="Points Total" />
                                <UiOrderDetailsColLabel
                                    label={kFormatter(props.order.totalPoints)}
                                />
                            </UiOrderDetailsColWr>
                        </UiCol>
                        <UiCol lg="4">
                            <UiOrderDetailsLastColWr>
                                <UiOrderDetailsLastCol>
                                    <UiOrderDetailsColWr>
                                        <UiOrderDetailsColName colName="Status" />
                                        <UiOrderDetailsColStatus
                                            status={
                                                props.order.orderStatus ==
                                                orderStatus.COMPLETED
                                                    ? "Completed"
                                                    : props.order.orderStatus ==
                                                      orderStatus.EXPIRED
                                                    ? "Expired"
                                                    : props.order.orderStatus ==
                                                      orderStatus.FAILED
                                                    ? "Failed"
                                                    : "Ordered"
                                            }
                                        />
                                    </UiOrderDetailsColWr>
                                    <UiOrderDetailsColWr>
                                        <UiOrderDetailsColName colName="Valid Unit" />
                                        <UiOrderDetailsColValidUnit
                                            validUnit={timeFormatUtcToLocal(
                                                props.order.expiryDate,
                                            )}
                                        />
                                    </UiOrderDetailsColWr>
                                </UiOrderDetailsLastCol>
                                <UiOrderDetailsLastColBtnWr>
                                    <UiButtonPrimary
                                        onClick={() =>
                                            navigate(
                                                "/app/shop/order-details/" +
                                                    props.order.orderId,
                                            )
                                        }
                                        btnName="View Order"
                                        size="45"
                                    />
                                </UiOrderDetailsLastColBtnWr>
                            </UiOrderDetailsLastColWr>
                        </UiCol>
                    </UiSingleRow>
                </UiOrderDetails>
                <div className="p-3">
                    <UiSingleRow>
                        <UiCol lg="4" xl="4">
                            <img
                                src={props.order.imageUrl}
                                className="img-fluid sb-product-info-img sb-product-info-lg"
                            />
                        </UiCol>
                        <UiCol lg="8" xl="8">
                            <VoucherWalletContent
                                showHideQr={showHideQr}
                                order={props.order}
                            />
                        </UiCol>
                    </UiSingleRow>
                </div>
            </UiVoucherDetailsWr> */}
            {/* <UiBottomNavBar>

                <UiBottomNavBarItem
                    navIcon={BottomNavIcon}
                    navTitle="Product"
                    hash="product"
                />
                <UiBottomNavBarItem
                    navIcon={HelpIcon}
                    navTitle="Help"
                    hash=""
                />

            </UiBottomNavBar> */}
        </>
    );
}
